import { useAtom, useAtomValue, useSetAtom } from "jotai";
import { useState } from "react";
import { Button, Dialog, Heading, Modal, ModalOverlay } from "react-aria-components";
import { toast } from "sonner";
import { inputClass } from "@/lib/forms";
import { atoms } from "@/state";

export const ReportDialog: React.FC = () => {
  const [isOpen, setIsOpen] = useAtom(atoms.reports.isOpen);
  const context = useAtomValue(atoms.reports.draftContext);
  const close = useSetAtom(atoms.reports.close);
  const submitMutation = useAtomValue(atoms.reports.submit);
  const [body, setBody] = useState("");

  const onSubmit = async () => {
    const trimmed = body.trim();
    if (!trimmed) {
      return;
    }
    try {
      await submitMutation.mutateAsync(trimmed);
      toast.success("Thanks — report sent");
      setBody("");
      close();
    } catch (err) {
      toast.error(err instanceof Error ? err.message : "Failed to send");
    }
  };

  return (
    <ModalOverlay
      isOpen={isOpen}
      onOpenChange={setIsOpen}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm data-[entering]:animate-in data-[exiting]:animate-out data-[entering]:fade-in data-[exiting]:fade-out"
      isDismissable
    >
      <Modal className="w-full max-w-md rounded-2xl bg-white shadow-xl outline-none dark:bg-gray-900">
        <Dialog className="flex flex-col gap-4 p-6 outline-none">
          {({ close: dlgClose }) => (
            <>
              <Heading slot="title" className="text-lg font-semibold dark:text-gray-100">
                Report an issue
              </Heading>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                Something wrong with this decode? Tell us what's off — the Squint team will triage
                and circle back.
              </p>
              {context?.code && (
                <div className="rounded-md bg-gray-50 px-3 py-2 font-mono text-xs text-gray-700 dark:bg-gray-800 dark:text-gray-300">
                  Context: {context.code}
                </div>
              )}
              <textarea
                autoFocus
                value={body}
                onChange={(e) => setBody(e.target.value)}
                rows={5}
                placeholder="What's wrong? What did you expect?"
                className={inputClass}
              />
              <div className="flex justify-end gap-2 pt-2">
                <Button
                  onPress={() => {
                    setBody("");
                    dlgClose();
                  }}
                  className="rounded-md border border-gray-300 px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800"
                >
                  Cancel
                </Button>
                <Button
                  isDisabled={!body.trim() || submitMutation.isPending}
                  onPress={onSubmit}
                  className="rounded-md bg-blue-600 px-3 py-1.5 text-sm font-medium text-white shadow-sm hover:bg-blue-700 disabled:opacity-50"
                >
                  {submitMutation.isPending ? "Sending…" : "Send report"}
                </Button>
              </div>
            </>
          )}
        </Dialog>
      </Modal>
    </ModalOverlay>
  );
};
